var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal-text-manager",
    class: {
      'legal-text-manager--has-controls': _vm.hasControls
    }
  }, [(_vm.internalValue && _vm.internalValue.length) ? _c('table', {
    staticClass: "uk-table uk-table-divider uk-margin-remove"
  }, [_c('thead', [_c('tr', [(_vm.hasControls) ? _c('th', {
    staticClass: "uk-table-shrink"
  }) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('fields.name')))]), _vm._v(" "), (_vm.hasControls) ? _c('th') : _vm._e()])]), _vm._v(" "), _c('draggable', {
    attrs: {
      "element": "tbody",
      "options": {
        handle: '.drag-handle'
      }
    },
    on: {
      "end": _vm.onInput
    },
    model: {
      value: (_vm.internalValue),
      callback: function($$v) {
        _vm.internalValue = $$v
      },
      expression: "internalValue"
    }
  }, _vm._l((_vm.internalValue), function(item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "legal-text-manager__row"
    }, [(_vm.hasControls) ? _c('td', {
      staticClass: "uk-table-shrink"
    }, [_c('drag-handle', {
      attrs: {
        "disabled": _vm.internalValue.length <= 1
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'edit-legal-text',
          params: {
            id: item.id
          }
        },
        "title": item.plainBody
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("truncate")(item.plainBody, 100)) + "\n          ")])], 1), _vm._v(" "), (_vm.hasControls) ? _c('td', [_c('data-grid-actions', {
      attrs: {
        "edit-route": {
          name: 'edit-legal-text',
          params: {
            id: item.id
          }
        }
      },
      on: {
        "remove": function($event) {
          _vm.removeLegalTextWhenConfirmed(index)
        }
      }
    })], 1) : _vm._e()])
  })), _vm._v(" "), (_vm.hasControls) ? _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "uk-padding-remove-left uk-padding-remove-right",
    attrs: {
      "colspan": "3"
    }
  }, [_c('common-button', {
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.$refs.legalTextPicker.show()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('actions.add')) + "\n          ")])], 1)])]) : _vm._e()], 1) : _c('div', {
    staticClass: "uk-placeholder uk-text-center uk-margin-remove"
  }, [_c('div', [_vm._t("empty", [_vm._v("\n        " + _vm._s(_vm.$t('hints.empty')) + "\n      ")])], 2), _vm._v(" "), (_vm.hasControls) ? _c('common-button', {
    staticClass: "uk-margin-top",
    attrs: {
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.$refs.legalTextPicker.show()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('actions.add')) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('legal-text-picker-modal', {
    ref: "legalTextPicker",
    attrs: {
      "title": "Rechtstext hinzufügen",
      "selectedLegalTexts": _vm.internalValue,
      "disabled": _vm.disabled
    },
    on: {
      "onSelect": _vm.addLegalTexts
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0364527c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LegalTextManager.vue
// module id = 1835
// module chunks = 0